import React, { Fragment } from "react";
import { Flex, Box } from "grid-styled";
import LabelWithIcon from "./LabelWithIcon";
import { STORE_MALL_DIRECTORY } from "../icons";
import { H1, H2 } from "./Heading";
import { contactDisplayName } from "../utils/helpers";
import ContractTotal from "./ContractTotal";

const JobHeader = ({ job, onFranchiseClick, contractsPath }) => (
  <Flex justify="space-between" align="center">
    <Box>
      <H2 style={{ marginTop: 0, marginBottom: 0 }}>{job.contractNumber}</H2>
      <H1 style={{ marginTop: "2px", marginBottom: "8px" }}>
        {contactDisplayName(job.contact)}
      </H1>
      <LabelWithIcon
        icon={STORE_MALL_DIRECTORY}
        style={{ cursor: onFranchiseClick ? "pointer" : "auto" }}
        onClick={onFranchiseClick}
      >
        {job.franchise ? (
          <Fragment>
            <code>
              <b>{job.franchise.assignedInHouseTty}</b>
            </code>{" "}
            {job.franchise.name}
          </Fragment>
        ) : (
          "No franchise"
        )}
      </LabelWithIcon>
    </Box>
    <Box>
      <ContractTotal job={job} contractsPath={contractsPath} />
    </Box>
  </Flex>
);

export default JobHeader;



// WEBPACK FOOTER //
// ./src/components/JobHeader.js